import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../../crbt/crbtuicss';

export interface BannerListCSSStyle extends CRBTUICSSStyle
{
    getBannerCSSStyle(): object;
}

export class BannerListCSSStyleImpl extends CRBTUICSSStyleImpl implements BannerListCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '100%', 
            width: '100%',
            fontFamily: this.getContext().getResources().getFontFamily(),
            // display: "flex",
        };
    }

    getBannerCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerlist/bannerlistcss.tsx